/**
 * Crisp Chat Integration
 *
 * Initializes the Crisp chat widget with the bubble hidden by default.
 * The widget is opened programmatically via the Support button in the sidebar.
 */

const CRISP_WEBSITE_ID = import.meta.env.VITE_CRISP_WEBSITE_ID as string | undefined;

if (CRISP_WEBSITE_ID) {
  window.$crisp = [];
  window.CRISP_WEBSITE_ID = CRISP_WEBSITE_ID;

  window.$crisp.push(['safe', true]);
  window.$crisp.push(['do', 'chat:hide']);
  window.$crisp.push(['on', 'chat:closed', () => {
    window.$crisp?.push(['do', 'chat:hide']);
  }]);

  const s = document.createElement('script');
  s.src = 'https://client.crisp.chat/l.js';
  s.async = true;
  document.head.appendChild(s);
}
